/**
 * =============<< ********* >>=============
 * Author       : Tony NGUEREZA
 * Email        : nguerezatony@gmail.com
 * Organization : Quantum Software Foundation Ltd.
 * Created On   : 2025-09-29
 * Title        :
 * Description  :
 * Copyright (c) 2025 Quantum Software Foundation Ltd..
 * =============<< ********* >>=============
 */
export const apiURL = {
    refreshToken: '/auth/token',
};